import axios from "axios";
// import util from '@/util/util'
import store from "@/store/index";
import { Message } from "element-ui";
const Axios = axios.create({
  // baseURL,
  timeout: 30000,
  responseType: "json",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    // "Content-Type": "application/x-www-form-urlencoded"
  },
});

function setSpaceToNull(obj) {
  if (["boolean", "string", "number"].indexOf(typeof obj) > -1) {
    return obj;
  } else if (typeof obj == "undefined") {
    return "";
  } else if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      obj[i] = setSpaceToNull(obj[i]);
    }
    return obj;
  } else if (typeof obj == "object") {
    for (var key in obj) {
      if (typeof obj[key] == "object") {
        obj[key] = setSpaceToNull(obj[key]);
      } else {
        obj[key] = obj[key] !== "" ? obj[key] : null;
      }
    }
  }

  return obj;
}
function setNullToSpace(obj) {
  if (["boolean", "string", "number"].indexOf(typeof obj) > -1) {
    return obj;
  } else if (typeof obj == "undefined") {
    return "";
  } else if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      obj[i] = setNullToSpace(obj[i]);
    }
    return obj;
  } else if (typeof obj == "object") {
    if (obj === null) {
      return "";
    } else {
      for (var key in obj) {
        obj[key] = setNullToSpace(obj[key]);
      }
    }
  }
  return obj;
}
// 请求前置拦截器
Axios.interceptors.request.use(
  (config) => {
    //如果是空字符串,传null
    // config.data = setSpaceToNull(config.data);

    config.headers.Authorization = `Bearer ${store.state.user.token}` || "";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 返回响应拦截器
Axios.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      // if(res.data.code == 0){
      return res.data;
      // }
      // return res.data
    }
    return res;
  },
  (error) => {
    if (error.response.status == 401) {
      //登录信息失效
      // localStorage.setItem('token', "");
      // store.state.user.token
      // store.commit("user/logout");
      store.commit("user/removeUserData");

      window.location.href = window.location.href.replace(/#.*/, "#/login");
    }
    return {
      error,
    };
  },
);

const request = (url, data = {}, method = "post", layerFlag = true) => {
  return new Promise((resolve, reject) => {
    Axios({
      method,
      url: url,
      data,
    })
      .then((res) => {
        if (res.code == 401) {
          store.commit("user/logout");
          // localStorage.setItem('token', "");
          window.location.href = window.location.href.replace(/#.*/, "#/login");
        } else if (res.code == 0) {
          resolve(res.data);
        } else if (res.code == -1) {
          Message.warning(res.msg);
          reject(res);
        } else if (res.code == -2) {
          reject(res);
        } else {
          Message.warning(res.msg);
          reject(res);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default request;

export var http2 = (url, data = {}, method = "post", layerFlag = true) => {
  return new Promise((resolve, reject) => {
    Axios({
      method,
      url: url,
      data: setNullToSpace(data),
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
